<template>
    <base-modal
        classes="modal-sm"
        @close="$emit('close')"
    >
        <div
            slot="header"
            class="h5"
        >
            Sauvegarde de recherche
        </div>

        <div slot="body">
            <div class="row">
                <div class="col-12">
                    <base-input
                        v-model="nom"
                        focus
                    >
                        Nom de la recherche
                    </base-input>
                </div>
            </div>
        </div>

        <div slot="footer">
            <button
                class="btn btn-success mr-2"
                @click="saveSearch"
            >
                Enregistrer
            </button>
            <button
                class="btn btn-danger"
                @click="$emit('close')"
            >
                Annuler
            </button>
        </div>
    </base-modal>
</template>

<script>
    import BaseModal from "../templates/BaseModal"
    import BaseInput from "../templates/BaseInput"

    export default {
        name: "SearchEditModal",

        components: {BaseModal, BaseInput},

        props: {
            emplacement: {type: String, default: null},
            filters: {
                type: Object, default: () => {
                }
            },
        },

        data: function () {
            return {
                nom: '',
            }
        },

        methods: {
            saveSearch: function () {
                this.saving = true

                axios.request({
                    url: '/api/recherches-sauvegardees',
                    method: 'post',
                    data: {nom: this.nom, filtres: JSON.stringify(this.filters), emplacement: this.emplacement},
                }).then(() => {
                    this.$notify('success', 'La recherche a bien été enregistrée.')
                    this.$emit('reload')
                    this.$emit('close')
                }).catch(error => {
                    if (error.response.data.errors) {
                        this.errors = error.response.data.errors
                    } else {
                        this.$notify('danger', 'Une erreur est survenue lors de la mise à jour de la recherche.')
                    }
                }).finally(() => this.saving = false)
            },
        }
    }
</script>

<style lang="scss">
.small-wysiwyg .jodit_workplace {
  height: 360px !important;
}

.small-wysiwyg .jodit_container {
  height: 440px !important;
}
</style>
